import { render, staticRenderFns } from "./EvitarSuspensionesHolder.vue?vue&type=template&id=08344e94"
import script from "./EvitarSuspensionesHolder.vue?vue&type=script&lang=js"
export * from "./EvitarSuspensionesHolder.vue?vue&type=script&lang=js"
import style0 from "./EvitarSuspensionesHolder.vue?vue&type=style&index=0&id=08344e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports